// extracted by mini-css-extract-plugin
module.exports = {"formBox":"style__formBox__IX+oM"};